import React from 'react'
import ReactDOM from 'react-dom/client'
import { Auth0Provider } from '@auth0/auth0-react'
import { AuthProvider } from './context/AuthContext'
import { Application } from './application'
import { initAnalytics } from './analytics/analytics'
import './index.css'

const auth0Domain = process.env.REACT_APP_AUTH0_DOMAIN
const auth0ClientId = process.env.REACT_APP_AUTH0_CLIENT_ID
const auth0Audience = process.env.REACT_APP_AUTH0_AUDIENCE

if (!auth0Domain || !auth0ClientId || !auth0Audience) {
  throw new Error(
    'Missing required Auth0 environment variables. Check your .env file.',
  )
}

initAnalytics()

const keepLoggedIn = localStorage.getItem('keepLoggedIn') !== 'false'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <Auth0Provider
    domain={auth0Domain}
    clientId={auth0ClientId}
    cacheLocation={keepLoggedIn ? 'localstorage' : 'memory'}
    // cacheLocation='localstorage'
    useRefreshTokens={true}
    authorizationParams={{
      redirect_uri: window.location.origin,
      audience: auth0Audience,
      scope: 'openid profile email offline_access',
    }}
  >
    <AuthProvider>
      <Application />
    </AuthProvider>
  </Auth0Provider>,
)
